import React from 'react';
import { useTranslation } from 'react-i18next';

import { useOidc } from '@axa-fr/react-oidc';
import { Button, Callout, Text } from '@fly/core';
import { PlatformService } from '@fly/platform-service';
import { FlyLoader } from '@fly/shared-ui';
import { FlySvgSprite } from '@fly/svg';

import { redirectUri } from '../../authConfig';
import styles from './LoginError.module.less';

export const LoginError = () => {
  const { t } = useTranslation();
  const { logout } = useOidc();

  PlatformService.getInstance().setLogoutFunction(logout);

  const clickLogout = () => {
    const platformService = PlatformService.getInstance();
    platformService.logout(redirectUri);
  };

  const errorMessage = t('app.auth.error.title', {
    defaultValue: 'Authentication Failed',
  });

  const errorDescription = t('app.auth.error.description', {
    defaultValue: "We couldn't complete your login. Please try again.",
  });

  const goToLoginText = t('app.auth.error.go_to_login', {
    defaultValue: 'Go to Login',
  });

  // TODO: Find better solution for this.
  // Workaround for password reset flow, when the session storage is not populated with OIDC data from @axa-fr/react-oidc.
  const oidcDefault = sessionStorage.getItem('oidc.default');
  if (oidcDefault === null) {
    return <FlyLoader />;
  }

  return (
    <div className={styles.errorContainer} data-testid='auth-error'>
      <div className={styles.errorWrapper}>
        <FlySvgSprite name='warning' size={48} />
        <div className={styles.errorContent}>
          <Text size='4' weight='bold'>
            {errorMessage}
          </Text>
          <Callout
            title={<Text>{errorDescription}</Text>}
            icon='info_circled'
            size='1'
            variant='soft'
            color='red'
          />
          <div className={styles.errorActions}>
            <Button
              size='2'
              variant='outline'
              className='text-slate-12'
              onClick={clickLogout}
            >
              {goToLoginText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
